import React from 'react'
import {useTranslation} from 'react-i18next'

import {OntarioRow} from '../../theme'

import {
  FooterContainer,
  FooterColumn,
  FooterLinkContainer,
  FooterLink,
} from './styles'

const Footer = () => {
  const {t} = useTranslation('common')
  const links = [...t('footer.links', {returnObjects: true})]

  const currentDate = new Date().getFullYear().toString().slice(-2)

  return (
    <FooterContainer>
      <OntarioRow>
        <FooterColumn>
          <FooterLinkContainer>
            {links
              ? links.map((link, index) => (
                  <li key={`footer-link-${index}`}>
                    <FooterLink href={link.url}>{link.name}</FooterLink>
                  </li>
                ))
              : null}
          </FooterLinkContainer>
          <div>
            <FooterLink href={t('footer.kingsPrinter.url')}>
              {t('footer.kingsPrinter.name')}
              {currentDate}
            </FooterLink>
          </div>
        </FooterColumn>
      </OntarioRow>
    </FooterContainer>
  )
}
export default Footer
